import { useCallback, useEffect, useRef, useState } from 'react';
import { postApi } from '../lib/api';

export function useRequestSubmission(path, onSaved) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [receipt, setReceipt] = useState(null);
  const requestId = useRef(null);
  if (requestId.current === null) requestId.current = crypto.randomUUID();
  const lock = useRef(false);
  const generation = useRef(0);
  useEffect(() => () => { generation.current++; }, []);
  const clearError = useCallback(() => setError(''), []);

  const submit = useCallback(async payload => {
    if (lock.current) return;
    const token = generation.current;
    lock.current = true; setBusy(true); setError('');
    try {
      const saved = await postApi(path, { ...payload, requestId: requestId.current });
      if (generation.current !== token) return;
      setReceipt(saved);
      onSaved?.(saved);
    } catch (failure) {
      if (generation.current === token) setError(failure.message);
    } finally {
      if (generation.current === token) { lock.current = false; setBusy(false); }
    }
  }, [path, onSaved]);

  const reset = useCallback(() => {
    generation.current++; lock.current = false; requestId.current = crypto.randomUUID();
    setReceipt(null); setBusy(false); setError('');
  }, []);
  return { busy, error, receipt, clearError, submit, reset };
}